import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4d744d9a&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=4d744d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d744d9a",
  null
  
)

export default component.exports